var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_1617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93359 6.17725V12.6304C2.93359 12.7464 2.97969 12.8577 3.06173 12.9397C3.14378 13.0218 3.25506 13.0679 3.37109 13.0679H5.99609V9.34912C5.99609 9.17507 6.06523 9.00815 6.1883 8.88508C6.31138 8.76201 6.4783 8.69287 6.65234 8.69287H8.83984C9.01389 8.69287 9.18081 8.76201 9.30388 8.88508C9.42695 9.00815 9.49609 9.17507 9.49609 9.34912V13.0679H12.1211C12.2371 13.0679 12.3484 13.0218 12.4305 12.9397C12.5125 12.8577 12.5586 12.7464 12.5586 12.6304V6.17725",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8711 7.38038L8.04387 1.80226C7.90715 1.65788 7.5875 1.65624 7.44832 1.80226L1.62109 7.38038M11.6836 5.27491V2.13038H10.3711V4.0171",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.746094 0.380371)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ef06604f9b76ae399f05f6e95c76a2b8.svg";
export { ForwardRef as ReactComponent };